function methodSelectDirective() {
	return {
		scope : {
			methodElement : '=',
			required : '@',
			technique : '@'
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/methodSelectDirective.html';
		},
		controller : [
				'$scope',
				'$window',
				'alertService',
				'analysisService',
				function($scope, $window, alertService, analysisService) {
					$scope.methodElements = [];
					var filter = {};
					
						$scope.searchElements = function(query) {
							
							if ($scope.name) {
								filter.name = $scope.filter.name;
							}
							if ($scope.technique != "") {
								filter.technique = $scope.technique;
							

							analysisService.searchMethodInTechnique(filter).then(
									function(response) {
										$scope.methodElements = response.getData();
									}, function(response) {
										//on error
									});
							}
						};
					
					$scope.$watch("technique", function(newValue, oldValue) {
						if (newValue == undefined) {

							filter.technique = "0";

						} else {
							$scope.methodElements = [];
							
							$scope.methodElement.selected = "";
							filter.technique = newValue;
							$scope.searchElements('query');

						}
					});

				} ]

	};
};

module.directive('methodSelect', [ methodSelectDirective ]);